module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_16-3f1160ff444cc61c3b1d7be9cd6b63c7.png";